import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CONFIG from "../utils/config";

const Online = () => {
  const navigate = useNavigate();
  const { encryptedData } = useParams();

  useEffect(() => {
    const fetchAndNavigate = async () => {
      if (!encryptedData) {
        console.error('Missing encryptedData path param');
        return;
      }

      try {
        const response = await fetch(
          `${CONFIG.BASE}/insurance/fetch-by-policy/${encodeURIComponent(encryptedData.trim())}`
        );

        if (response.ok) {
          const data = await response.json();
          if (data && data.id) {
            navigate('/motor', { state: { id: data.id } });
          } else {
            console.error("Data missing 'id', cannot navigate");
          }
        } else {
          console.error("Fetch failed with status:", response.status);
        }
      } catch (error) {
        console.error("Network or parsing error:", error);
      }
    };

    fetchAndNavigate();
  }, [encryptedData, navigate]);

  return null;
};

export default Online;
